(function componentForm($, Adzuki, tinymce) {
	'use strict';

	var form = {
		name: 'Ecard',
	};

	$(document).ready(function onDocumentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.load = function onFormLoad()
	{
		var scroll_limit               = 160; // 200
		var scroll_limit_desc_open     = 450;
		var ecard_message_editor       = null;
		var selected_travel_components = [];
		var preview_data               = {};
		var total_editors              = 9;
		var editor_index               = 0;
		var ecard_options              = $('.ecard-options');
		var form_action                = ecard_options.data('action');

		var radios = [
			'.ecard-opt-in',
			'.ecard-text-message-opt-in',
			'.ecard-cp-mobile-app',
			'.ecard-survey',
			'.ecard-testimonial',
			'.ecard-authorization',
			'.ecard-waiver',
			'.ecard-pandemic-waiver',
			'.ecard-cruise-sheet',
			'.ecard-virtual-event',
			'.ecard-trip-summary',
			'.ecard-travel-components',
			'.ecard-include-offers',
			'.ecard-video',
			'.ecard-vendor-landing-page',
			'.ecard-microsite',
		];

		var asset_dropdowns = [
			'.ecard-template',
			'.ecard-text',
			'.ecard-text-position',
			'.ecard-scene',
			'.ecard-photo',
			'.ecard-photo-position',
			'.ecard-color',
			'.ecard-border',
			'.ecard-message'
		];

		/**
		 * Update the preview iframe with the selected properties.
		 */
		var updatePreview = Adzuki.Debounce(function updatePreview()
		{
			// disable all links in the preview
			preview_data['disable-links'] = 1;

			$.post(Adzuki.base_uri + '/Ecards/preview', preview_data, function updateEcardPreview(response)
			{
				var ecard_iframe         = document.getElementById('ecard-preview-contents');
				var ecard_frame_document = ecard_iframe.contentDocument || ecard_iframe.contentWindow.document;

				ecard_frame_document.documentElement.innerHTML = response;
			});
		}, 250);

		// setup ecard preview affix
		$('.ecard-preview').affix({
			offset: {
				top: getScrollLimit
			}
		});

		// show template name text field
		$('.save-as-template').on('click', function onSaveTemplateClick(e)
		{
			$('.save-template').toggleClass('hidden');
		});

		// had to overwrite the affix event because I have to substract the padding
		// on the .box element, this way the preview is displayed correctly
		$(document).on('affixed.bs.affix', function fixAffixWidth(e)
		{
			var $affixed = $(e.target);
			var $parent  = $affixed.parent();

			$affixed.width($parent.width() - 30);
		});

		// Initialize TinyMCE for ecard message and travel component descriptions
		Adzuki.Editor('#ecard-editor, .travel-type-editor', {
			init_instance_callback: function onEditorInit(editor)
			{
				editor_index++;

				if (editor.id === 'ecard-editor') {
					ecard_message_editor = editor;
				}

				// update preview when changing the message or any travel component description
				editor.on('blur', function onEditorBlur(e) {
					var component_index        = 0;
					var component_editor_index = 0;

					if (editor.id === 'ecard-editor') {
						preview_data.message = editor.getContent();
					} else {
						component_editor_index = editor.id[editor.id.length - 1];
						component_index        = parseInt(component_editor_index) - 1; // arrays start at 0!

						selected_travel_components[component_index] = {};
						selected_travel_components[component_index]['travel_type'] = $('.select-travel-type-' + component_editor_index).val();
						selected_travel_components[component_index]['travel_description'] = editor.getContent();

						preview_data['travel-components']['components'] = selected_travel_components;
					}

					updatePreviewData();
					updatePreview();
				});

				// trigger dropdown change events, for the options to include stuff (cruise sheets, trip summary etc. etc)
				// also triggering the blur for text links when the tinyMCE editor is available
				// since there are 9 editors, I have to wait until all of them are loaded
				// there's gotta be a better way to check this
				if (total_editors === editor_index) {
					$.each(radios, function onEachRadioOption(key, value)
					{
						var radio_name = value.replace('.ecard-', '');

						$('.' + radio_name + '-field').trigger('blur');
						$('.select-' + radio_name).trigger('change');
						$('.select-include-offer').trigger('change');
					});
				}
			}
		});

		// update the preview when the value of one of the asset dropdowns (scene, text, photo etc.) change
		$(asset_dropdowns.join()).change(function onAssetDropdownChange(e)
		{
			var asset_id                      = $(e.target).val();
			var asset_type                    = $(e.target).data('asset-type');
			var previous_template_attachments = $('.ajaxed-file');

			// selecting a template, update the dropdowns and the preview
			if (asset_type === 'template' && asset_id !== "") {
				$.get(Adzuki.base_uri + '/Ecards/getTemplate/' + asset_id, function getEcardTemplate(response)
				{
					Adzuki.DragDropUpload.init($('#ecard-file'));

					// remove attachments associated with any previously selected template
					$.each(previous_template_attachments, function removeEachTemplateAttachment(key, value)
					{
						var $self       = $(this),
						    $remove_btn = $self.find('.attachment-remove');

						$remove_btn.trigger('click');
					});
					Adzuki.DragDropUpload.appendFilesToForm(response.attachments, true);

					$.each(asset_dropdowns, function eachAssetDropdown(key, value)
					{
						var asset      = $(asset_dropdowns[key]);
						var asset_name = asset_dropdowns[key].replace('.ecard-', '');

						// don't update the template dropdown :)
						if (asset_name === 'template') {
							return true;
						}

						// update the message
						// for some reason I also gotta prepopulate the actual textarea
						// so that it doesn't fail validation
						if (asset_name === 'message') {
							ecard_message_editor.setContent(response['message']);
							$('.ecard-message').val(response['message']);
							return true;
						}

						// update everything else (text, photo, scene etc etc.)
						asset.val(response[asset_name]);
					});

					// don't update the from field if the value from the template is blank (happens with global templates)
					if (response.from !== '') {
						$('.ecard-from').val(response.from);
					}

					$('.ecard-subject').val(response.subject);

					updatePreviewData();
					updatePreview();
				});

				return;
			}

			updatePreviewData();

			// update the ecard asset that was actually changed
			preview_data[asset_type] = asset_id;

			updatePreview();
		});

		// Recalculate top position of preview
		// when the ecard instructions box is opened
		$('.js-scroll-limit').on('click', function onMinusClick(e)
		{
			var $self = $(this);
			$self.toggleClass('plus');
			$self.toggleClass('minus');

			$('.ecard-desc').collapse('toggle');
		});

		// update the preview when the value of one of the
		// radio buttons to include stuff change (opt in link, cruise sheet etc.)
		$(radios.join()).change(function onRadioChange(e)
		{
			var radio_name  = $(e.target).attr('class').replace('ecard-', '');
			var radio_value = $(e.target).val();

			// toggle visibility of the text link text field
			$('.' + radio_name + '-text').toggleClass('hidden');

			preview_data[radio_name] = {};
			preview_data[radio_name].include = radio_value;

			if (radio_name === 'opt-in') {
				// set the preview with the default value of the optin text
				preview_data[radio_name].link_text = $('.' + radio_name + '-field').val();
			} else if (radio_name === 'text-message-opt-in') {
				preview_data[radio_name].link_text = $('.' + radio_name + '-field').val();
			} else if (radio_name === 'cp-mobile-app') {
				preview_data[radio_name].link_text = $('.' + radio_name + '-field').val();
			} else if (radio_name === 'survey') {
				// set the preview with the default value of the survey text
				preview_data[radio_name].link_text = $('.' + radio_name + '-field').val();
			} else if (radio_name === 'testimonial') {
				// set the preview with the default value of the testimonial text
				preview_data[radio_name].link_text = $('.' + radio_name + '-field').val();
			} else if (radio_name === 'authorization') {
				// set the preview with the default value of the authorization text
				preview_data[radio_name].link_text = $('.' + radio_name + '-field').val();
			} else if (radio_name === 'waiver') {
				// set the preview with the default value of the waiver text
				preview_data[radio_name].link_text = $('.' + radio_name + '-field').val();
			} else if (radio_name === 'pandemic-waiver') {
				// set the preview with the default value of the pandemic waiver text
				preview_data[radio_name].link_text = $('.' + radio_name + '-field').val();
			} else if (radio_name === 'video') {
				// set the preview with the default value of the video text
				preview_data[radio_name].link_text = $('.' + radio_name + '-field').val();
				$('.' + radio_name + '-list').toggleClass('hidden');
			} else {
				$('.' + radio_name + '-list').toggleClass('hidden');

				// reset dropdowns for radios, when the value is set to "No"
				if (radio_value === 'no') {
					$('.' + radio_name + '-list-item').addClass('hidden');
					$('.' + radio_name + '-list-item').find('select').val('1');
					$('select.select-' + radio_name).val('');
				}
			}

			updatePreviewData();
			updatePreview();
		});

		// update the preview when the value of one of the select inputs from the radio buttons change
		// or the text link of one of the text fields for opt in, trip summary and cruise sheet change
		$.each(radios, function eachRadioOption(key, value)
		{
			var radio_name = value.replace('.ecard-', '');
			var radio_value = 'no';

			// on the edit page, if one of the radios is set to "yes"
			// set the data accordingly for the ecard preview
			$(value).each(function onEachRadioValue(i, elem)
			{
				if ($(elem).is(':checked')) {
					radio_value = $(elem).val();
				}
			});

			preview_data[radio_name]         = {};
			preview_data[radio_name].include = radio_value;

			$('.' + radio_name + '-field').blur(function onTextLinkBlur(e)
			{
				preview_data[radio_name].link_text = $(e.target).val();

				updatePreviewData();
				updatePreview();
			});

			$('.select-' + radio_name).change(function onSelectInputChange(e)
			{
				var select_value    = $(e.target).val();
				var selected_offers = [];
				var i, j;

				// handle when including offers on the ecard
				if (radio_name === 'include-offers') {
					preview_data[radio_name]['amount'] = select_value;

					// display the correct amount of offer options
					for (i = 1; i <= 6; i++) {
						$('.include-offers-list-item-' + i).addClass('hidden');
					}

					// update selected offers object with any pre-selected offers.
					for (j = 1; j <= select_value; j++) {
						$('.include-offers-list-item-' + j).removeClass('hidden');

						if ($('.select-include-offer-' + j).val() !== '') {
							selected_offers[j] = $('.select-include-offer-' + j).val();
						}
					}

					// update selected offers when the value of any select changes
					$('.select-include-offer').change(function onSelectIncludeOfferChange(e)
					{
						var offer_select = $(e.target);

						selected_offers[offer_select.data('index')] = offer_select.val();
						preview_data[radio_name]['ids'] = updateOfferIds(selected_offers);

						updatePreviewData();
						updatePreview();
					});

					preview_data[radio_name]['ids'] = updateOfferIds(selected_offers);

					updatePreviewData();
					updatePreview();

					return;
				}

				// handle when including travel components on the ecard
				else if (radio_name === 'travel-components') {
					preview_data[radio_name]['amount'] = select_value;

					// display the correct amount of travel component options
					for (i = 1; i <= 8; i++) {
						$('.travel-components-list-item-' + i).addClass('hidden');

						selected_travel_components[i - 1] = {};
						selected_travel_components[i - 1]['travel_type'] = '';
						selected_travel_components[i - 1]['travel_description'] = '';
					}

					// update selected travel components object with any pre-selected travel components.
					for (j = 1; j <= select_value; j++) {
						$('.travel-components-list-item-' + j).removeClass('hidden');

						if ($('.select-travel-type-' + j).val() !== '') {
							selected_travel_components[j - 1] = {};
							selected_travel_components[j - 1]['travel_type'] = $('.select-travel-type-' + j).val();
							selected_travel_components[j - 1]['travel_description'] = tinymce.get('travel-description-' + j).getContent();
						}
					}

					// update selected travel components when the value of the select travel type changes
					$('.select-travel-type').change(function onSelectTravelTypeChange(e)
					{
						var travel_type_select = $(e.target);
						var component_index    = parseInt(travel_type_select.data('index')) - 1; // arrays start at 0!

						selected_travel_components[component_index] = {};
						selected_travel_components[component_index]['travel_type'] = travel_type_select.val();
						selected_travel_components[component_index]['travel_description'] = tinymce.get('travel-description-' + (component_index + 1)).getContent();

						preview_data[radio_name]['components'] = selected_travel_components;

						updatePreviewData();
						updatePreview();
					});

					preview_data[radio_name]['components'] = selected_travel_components;

					updatePreviewData();
					updatePreview();

					return;
				}

				preview_data[radio_name]['id'] = select_value;

				updatePreviewData();
				updatePreview();
			});
		});

		// update the preview when the modal for the visual lists
		// is hidden and the user makes a selection
		$('.modal').on('hidden.bs.modal', function onModalHidden()
		{
			updatePreviewData();
			updatePreview();
		});

		// selecting an event type on the ecard scheduler
		if ($('.select-event-type').length > 0) {
			Adzuki.Ajax.get(Adzuki.base_uri + '/Ecards/getSchedulerDays').then(function getSchedulerDays(response)
			{
				schedulerEventTypes(response);
			});
		}

		/**
		 * Manage selection of event types on the ecard scheduler
		 *
		 * @param {Object} schedule_days
		 *
		 * @return {void}
		 */
		function schedulerEventTypes(schedule_days)
		{
			var event_type_select = $('.select-event-type');
			var send_out_select   = $('.select-send-out');
			var send_out_label    = $('.send-out-label');
			var send_out          = $('.send-out');
			var days_after        = schedule_days.days_after;
			var days_before       = schedule_days.days_before;

			var no_send_option = [
				'client_anniversary',
				'client_birthday',
				'client_referral'
			];

			var full_send_option = {
				client_passport_expiration: {
					day  : 180,
					label: 'before expiration'
				},
				client_tsa_expiration: {
					day  : 180,
					label: 'before expiration'
				},
				client_uk_eta_expiration: {
					day  : 180,
					label: 'before expiration'
				},
				final_soft_payment: {
					day  : 7,
					label: 'before final payment due'
				},
				cruise_preregistration: {
					day  : 30,
					label: 'before departure'
				},
				cruise_departs: {
					day  : 3,
					label: 'before departure'
				},
				tour_final_soft_payment: {
					day  : 7,
					label: 'before final payment due'
				},
				tour_departs: {
					day  : 3,
					label: 'before departure'
				},
				package_final_soft_payment: {
					day  : 7,
					label: 'before final payment due'
				},
				package_departs: {
					day  : 3,
					label: 'before departure'
				}
			};

			var seven_day_send_option = {
				just_booked: {
					day  : 1,
					label: 'booking date'
				},
				cruise_returns: {
					day  : 3,
					label: 'return'
				},
				tour_just_booked: {
					day  : 1,
					label: 'booking date'
				},
				tour_returns: {
					day  : 3,
					label: 'return'
				},
				package_just_booked: {
					day  : 1,
					label: 'booking date'
				},
				package_returns: {
					day  : 3,
					label: 'return'
				}
			};

			var full_send_option_keys = $.map(full_send_option, function fullSendOptionMap(key, day) {
				return day;
			});

			var seven_day_send_option_keys = $.map(seven_day_send_option, function sevenDaySendOptionMap(key, day) {
				return day;
			});

			// changing the event type dropdown for the schedule
			event_type_select.change(function onEventTypeSelectChange(e)
			{
				var event_type = $(e.target).val();

				send_out.removeClass('hidden');
				send_out_select.find('option').remove();

				// hide "Send Out" option for those event types that don't need it.
				if ($.inArray(event_type, no_send_option) !== -1) {
					send_out.addClass('hidden');
				}

				// use 7 days options list
				if ($.inArray(event_type, seven_day_send_option_keys) !== -1) {
					addDaysOptions(days_after, send_out_select);

					send_out_select.val(seven_day_send_option[event_type]['day']);
					send_out_label.html('after ' + seven_day_send_option[event_type]['label']);
				}

				// use 180 days options list
				if ($.inArray(event_type, full_send_option_keys) !== -1) {
					addDaysOptions(days_before, send_out_select);

					send_out_select.val(full_send_option[event_type]['day']);
					send_out_label.html(full_send_option[event_type]['label']);
				}
			});

			// changing the send out day dropdown for the schedule
			send_out_select.change(function onSendOutSelectChange(e)
			{
				var current_day = $(e.target).val();
				var event_type  = event_type_select.val();
				var label       = '';

				if (seven_day_send_option[event_type] !== undefined) {
					label = seven_day_send_option[event_type]['label'];
				} else if (full_send_option[event_type] !== undefined) {
					label = full_send_option[event_type]['label'];
				}

				if (parseInt(current_day) === 0) {
					send_out_label.html(label);
				} else if ($.inArray(event_type, seven_day_send_option_keys) !== -1) {
					send_out_label.html('after ' + label);
				} else if ($.inArray(event_type, full_send_option_keys) !== -1) {
					send_out_label.html(label);
				}
			});

			if (form_action === 'add') {
				event_type_select.trigger('change');
			}

			send_out_select.trigger('change');
		}

		/**
		 * Add the specified <option>'s to the "Send Out" select dropdown.
		 *
		 * @param {array|Object} days
		 * @param {Object} send_out_select
		 *
		 * @return {void}
		 */
		function addDaysOptions(days, send_out_select)
		{
			$.each(days, function onEachDaysAfter(i, day) {
				send_out_select.append($('<option>', {
					value: i,
					text : day
				}));
			});
		}

		/**
		 * Create a comma delimited string of offer ids.
		 *
		 * @param  {Object} selected_offers
		 * @return {string}
		 */
		function updateOfferIds(selected_offers)
		{
			var offer_ids = [];

			$.each(selected_offers, function onEachSelectedOffer(offer_index, offer_id)
			{
				if (selected_offers[offer_index]) {
					offer_ids.push(offer_id);
				}
			});

			return offer_ids.join();
		}

		/**
		 * Update the preview_data object according to the values of the dropdown assets (scene, text, photo etc.)
		 *
		 * @return {void}
		 */
		function updatePreviewData()
		{
			$.each(asset_dropdowns, function eachDropdown(key, value)
			{
				var asset      = $(asset_dropdowns[key]);
				var asset_name = asset_dropdowns[key].replace('.ecard-', '');

				// special case for message, get contents from TinyMCE editor
				if (asset_name === 'message' && ecard_message_editor !== null) {
					preview_data['message'] = ecard_message_editor.getContent();
					return true;
				}

				preview_data[asset_name] = asset.val();
			});
		}

		/**
		 * Get the scroll limit value if the ecard
		 * description is open or not.
		 *
		 * @return {int}
		 */
		function getScrollLimit()
		{
			return ($('.ecard-desc').hasClass('in')) ? scroll_limit_desc_open : scroll_limit;
		}
	};

}(jQuery, window.Adzuki || {}, window.tinymce || {}));
